import { render } from "./TableA.vue?vue&type=template&id=299da185&scoped=true"
import script from "./TableA.vue?vue&type=script&lang=ts"
export * from "./TableA.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-299da185"

export default script